import { useCallback, useState } from 'react'
import {
  SigningFormFieldProps,
  buildSigningFieldPath,
} from '../components/Signing'

export const useSignatureState = ({
  onPersist,
  onClose,
  onSignaturePersisted,
  onDependentUpdate,
}: Pick<SigningFormFieldProps, 'onPersist'> & {
  onClose: () => void
  onSignaturePersisted?: (signature: string) => void
  onDependentUpdate?: (path: string, value: any) => void
}) => {
  const [isLoading, setIsLoading] = useState(false)

  const commitSignature = useCallback((signature: string) => {
    onPersist(signature)
      .then(({ dependant_updates }) => {
        if (onSignaturePersisted) {
          onSignaturePersisted(signature)
        }

        if (onDependentUpdate) {
          dependant_updates.forEach((dependantUpdate) => {
            onDependentUpdate(
              buildSigningFieldPath(dependantUpdate),
              dependantUpdate.value
            )
          })
        }

        onClose()
      })
      .finally(() => setIsLoading(false))
  }, [])

  return {
    isLoading,
    commitSignature,
  }
}
